import React, { Component } from 'react';
import { Steps } from 'antd-mobile';

const Step = Steps.Step;

const iconAllData = {
    iconProcess: (    
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="am-icon am-icon-md" version="1.1">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <rect strokeOpacity="0.3" stroke="#000000" strokeWidth="3" fill="#353C48" x="5" y="5" width="5" height="5" rx="5"></rect>
                        </g>
                    </svg>
                ),
    iconWait: (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="am-icon am-icon-md" version="1.1">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <rect fill="#BFBFBF" x="5.5" y="5.5" width="4" height="4" rx="3"></rect>
                        </g>
                    </svg>
                ),
    iconFinshed:(
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="am-icon am-icon-md" version="1.1">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <rect stroke="#353C48" strokeWidth="1" fill="#FFFFFF" x="5.5" y="5.5" width="4" height="4" rx="3"></rect>
                        </g>
                    </svg>
                )
}

export default class StepBar extends Component {
    constructor(props){
        super(props);
    }

    render() {
        const { count, stepData, status } = this.props;
        return (
            <Steps direction='horizontal' current={count}>
                {
                    stepData.map( ( item, value ) => {
                        return <Step key={value} status = { !status ? "wait" : ""} title={item.title} icon={iconAllData[item.iconName]} description={item.description}></Step>
                    })
                }
            </Steps>
        )
    }
}
